import { useHasSocialWallet } from '@/hooks/use-has-social-wallet';
import { SocialCurrency, useSocialCurrencyStore } from '@/hooks/use-social-currency';

/**
 * Whether the betslip is operating on the coins currency (social wallet with
 * coins active), which drives the coins validator set (validators-coins.ts)
 * and coins error messaging.
 */
export const useIsCoinsCurrency = () => {
    const hasSocialWallet = useHasSocialWallet();
    const activeCurrency = useSocialCurrencyStore(state => state.activeCurrency);

    return hasSocialWallet && activeCurrency === SocialCurrency.COINS;
};
